import * as React from "react";
import useRecorder from "./useRecorder";
import { useState } from "react";
import { imageURl } from "../../libs/env";
import AudioAnalyser from "../../components/audioVisualizer/AudioAnalyser";
import { find } from "lodash";
import {AES, enc}from 'crypto-js';
var audioChunks = [];

export const Speaking = ({ speakingUrl,setIsonRecorder,resetAudio,setresetAudio, answers,data_type,data_page_id, data_exercise_id , data_section_id,speaking_data,isReview, speakingResponseURL, Studentname }) => {
  const [Audioanalyzer, setAudioanalyzer] = useState(null);

  var audio_streaming_data = sessionStorage.getItem("audio_streaming_data");
  try {
    const decrypted = AES.decrypt(audio_streaming_data, 'MYKEY4DEMO');
    const decryptedstring = decrypted.toString(enc.Utf8);
    var audioUploadurl = decryptedstring.replace(/&amp;/g, "&")
  }
  catch (e) {
    console.log(e);
  }
  
  let [base64,audioURL, isRecording, startRecording, stopRecording, recorder] = useRecorder(audioChunks, audioUploadurl, Studentname, data_type, data_page_id, data_exercise_id, data_section_id, setAudioanalyzer);
  if (data_type === "Assessment"){
    if (base64 !== ""){
      let found_section = find(answers, ["section_id", data_section_id]);
      let found_page = find(answers, ["page_id", data_page_id]);
      let found_exercise = find(answers, ["exercise_id", data_exercise_id]);
      if (found_section && found_page && found_exercise) {
        found_exercise.answers = base64;
      } else {
        answers.push({
          section_id: data_section_id,
          page_id: data_page_id,
          exercise_id: data_exercise_id,
          answers: base64,
        });
      }
    }
  }
  else{
    speakingUrl(base64);
  }
  let found_section = find(answers, ["section_id", data_section_id]);
  let found_page = find(answers, ["page_id", data_page_id]);
  let found_exercise = find(answers, ["exercise_id", data_exercise_id]);
  let audio_content = 
  audioURL ? audioURL : found_section && found_page && found_exercise && found_exercise.answers ?
  found_exercise.answers : null;
  if (resetAudio){
    audio_content = null;
  }
  if(isRecording){
    setIsonRecorder(true);
  }
  if(!isRecording){
    setIsonRecorder(false);
  }
  if(isRecording && data_type === "Assessment"){
    audio_content = null;
    setresetAudio(false);
  }
  return (
    <div className="row ps-4 pe-0">
      { !isReview ?
      <div className="row col-12 ">
        <div className="col-lg-6 col-sm-12 d-flex">
          <button
            type="button"
            onClick={!isRecording ? startRecording : stopRecording}
            class="btn p-0"
          >
            <div>
              <span className="text-start">
                {!isRecording ?  (
                  <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="21.5" cy="21.5" r="21.5" fill="#F52F37"/>
                    <rect x="16.5391" y="6.61719" width="9.92308" height="18.1923" rx="4.96154" stroke="white" stroke-width="3.30769" stroke-linejoin="round"/>
                    <path d="M9.92428 19.8469C9.92428 22.9173 11.144 25.8619 13.3151 28.033C15.4862 30.2041 18.4308 31.4238 21.5012 31.4238C24.5716 31.4238 27.5162 30.2041 29.6873 28.033C31.8584 25.8619 33.0781 22.9173 33.0781 19.8469" stroke="white" stroke-width="3.30769" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M21.5 36.3839V33.0762" stroke="white" stroke-width="3.30769" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                )     
                :(
                  <img src={`${imageURl}/stop_mic.png`} width="43px" alt="Pause mic img" />
                )
                
                }
              </span>
            </div>
          </button>
          <div class="align-self-center ms-3">
              <span className="">
                {!isRecording ?  (
                  <p className="align-self-center record-line"></p>
                )     
                :(
                  Audioanalyzer? <AudioAnalyser audio={Audioanalyzer} width={198} height={60} />:
                  null
                  
                )
                }
              </span>
          </div>
        </div>
        <div className="col-lg-6 col-sm-12">
          <b> Click the red record button to start recording. Press again when you finished recording. </b>
        </div>
      </div>
      :null}
      <div className="col-12 mt-4" key={`${data_section_id}${data_page_id}${data_exercise_id}`}>
        <audio className="audio-size" src={isReview ? speakingResponseURL : audio_content} controls controlsList="noplaybackrate nodownload" />
      </div>
      <p className="pt-2 quiz-bottom-border"></p>
      {/* <div className="col-12">
              {speaking_data}
            </div> */}
    </div>
  );
};
